module.exports = __webpack_public_path__ + "2b4f9d9ce249aa2cba7cafaf995d9019.svg";